import React from 'react';
import './style.css';

export const ButtonOk: React.FC<{ onClick: () => void; disabled: boolean; label: string }> = props => {
  return (
    <div className="bg-button-next ml-3" onClick={props.onClick}>
      <p>{props.label}</p>
    </div>
  );
};
